import React from "react";

const Products = () => {
  const product = {
    name: "Minyak Nilam (Patchouli Oil)",
    description:
      "Patchouli oil is a high-quality natural essential oil extracted from the leaves of the patchouli plant through a distillation process. It has a distinctive warm, earthy, exotic, and long-lasting aroma.",
    keunggulan: [
      "100% natural patchouli oil",
      "Strong, distinctive, and long-lasting aroma",
      "Suitable for perfumes, aromatherapy, cosmetics, and soap",
      "Stable quality with the characteristic color and viscosity of patchouli",
      "Without the mix of harmful chemicals",
    ],
    kegunaan: [
      "Basic ingredients of perfume and fragrances",
      "Aromatherapy for relaxation",
      "A mix of skincare and body care products",
      "Cosmetic and pharmaceutical industry materials",
    ],
  };

  const industryTags = [
    "Parfume",
    "Cosmetics",
    "Aromatherapy",
    "Personal Care",
  ];

  return (
    <section
      id="products"
      className="py-5"
      style={{
        backgroundColor: "#ffffff",
        overflow: "hidden",
      }}
    >
      <div className="container py-lg-4">
        {/* Section Header */}
        <div className="text-center mb-5" data-aos="fade-down">
          <h5
            className="text-uppercase mb-3"
            style={{
              color: "#b68b40",
              fontSize: "clamp(0.9rem, 2vw, 1rem)",
              fontWeight: "600",
              letterSpacing: "4px",
            }}
          >
            Our Product
          </h5>
          <h2
            style={{
              color: "#1a3e3f",
              fontSize: "clamp(2rem, 5vw, 2.5rem)",
              fontWeight: "700",
              marginBottom: "10px",
            }}
          >
            Premium Patchouli Oil
          </h2>
          <p
            className="mx-auto"
            style={{
              color: "#6c757d",
              fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
              maxWidth: "700px",
            }}
          >
            One main product, the best quality from Indonesia
          </p>
          <div
            className="mx-auto"
            style={{
              width: "60px",
              height: "3px",
              background: "#b68b40",
              marginTop: "20px",
              borderRadius: "2px",
            }}
          />
        </div>

        {/* Product Card */}
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10">
            <div
              className="p-4 p-md-5"
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "30px",
                boxShadow: "0 15px 40px rgba(0,0,0,0.05)",
              }}
              data-aos="fade-up"
            >
              <div className="row align-items-center g-4 g-lg-5">
                {/* Left Column - Image */}
                <div className="col-12 col-md-5 text-center">
                  <div
                    className="position-relative d-inline-block w-100"
                    style={{ maxWidth: "350px" }}
                    data-aos="fade-right"
                  >
                    {/* Main Image */}
                    <div
                      className="ratio ratio-1x1 mx-auto"
                      style={{
                        maxWidth: "350px",
                      }}
                    >
                      <div
                        style={{
                          background:
                            "linear-gradient(145deg, #1a3e3f, #2a5556)",
                          borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 20px 30px rgba(26,62,63,0.3)",
                          border: "6px solid rgba(232,213,181,0.1)",
                          overflow: "hidden",
                        }}
                      >
                        <img
                          src="/product.jpg"
                          alt="Premium Patchouli Oil"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                          onError={(e) => {
                            e.target.src =
                              "https://via.placeholder.com/350x350?text=Patchouli+Oil";
                          }}
                        />
                      </div>
                    </div>

                    {/* Floating Badge - hidden on mobile */}
                    <div
                      className="d-none d-md-block position-absolute"
                      style={{
                        top: "20px",
                        left: "-15px",
                        backgroundColor: "white",
                        padding: "10px 20px",
                        borderRadius: "12px",
                        boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                        borderLeft: "4px solid #b68b40",
                      }}
                      data-aos="fade-right"
                      data-aos-delay="200"
                    >
                      <span
                        style={{
                          fontWeight: "600",
                          color: "#1a3e3f",
                          fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        100% Natural
                      </span>
                    </div>
                  </div>

                  {/* Industry Tags */}
                  <div
                    className="d-flex justify-content-center gap-2 flex-wrap mt-4"
                    data-aos="fade-up"
                    data-aos-delay="400"
                  >
                    {industryTags.map((tag, index) => (
                      <span
                        key={index}
                        className="badge bg-white text-dark px-3 py-2 rounded-pill"
                        style={{
                          fontSize: "clamp(0.8rem, 2vw, 0.85rem)",
                          fontWeight: "500",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                          border: "1px solid #edf2f7",
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Right Column - Description */}
                <div className="col-12 col-md-7" data-aos="fade-left">
                  <h3
                    style={{
                      color: "#1a3e3f",
                      fontSize: "clamp(1.5rem, 4vw, 2rem)",
                      fontWeight: "700",
                      marginBottom: "15px",
                    }}
                  >
                    {product.name}
                  </h3>

                  <p
                    style={{
                      color: "#4a5568",
                      fontSize: "clamp(0.95rem, 2vw, 1rem)",
                      lineHeight: "1.8",
                      marginBottom: "25px",
                    }}
                  >
                    {product.description}
                  </p>

                  <div className="row g-4">
                    {/* Keunggulan */}
                    <div className="col-12 col-sm-6">
                      <h4
                        className="position-relative pb-2 mb-3"
                        style={{
                          color: "#b68b40",
                          fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
                          fontWeight: "600",
                        }}
                      >
                        Superiority
                        <span
                          className="position-absolute bottom-0 start-0"
                          style={{
                            width: "40px",
                            height: "2px",
                            background: "#b68b40",
                          }}
                        />
                      </h4>
                      <ul className="list-unstyled">
                        {product.keunggulan.map((item, i) => (
                          <li
                            key={i}
                            className="d-flex gap-2 mb-2"
                            style={{
                              fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                            }}
                          >
                            <span
                              style={{
                                color: "#b68b40",
                                minWidth: "20px",
                              }}
                            >
                              ✓
                            </span>
                            <span style={{ color: "#2c3e50" }}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Kegunaan */}
                    <div className="col-12 col-sm-6">
                      <h4
                        className="position-relative pb-2 mb-3"
                        style={{
                          color: "#b68b40",
                          fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
                          fontWeight: "600",
                        }}
                      >Utility
                        <span
                          className="position-absolute bottom-0 start-0"
                          style={{
                            width: "40px",
                            height: "2px",
                            background: "#b68b40",
                          }}
                        />
                      </h4>
                      <ul className="list-unstyled">
                        {product.kegunaan.map((item, i) => (
                          <li
                            key={i}
                            className="d-flex gap-2 mb-2"
                            style={{
                              fontSize: "clamp(0.9rem, 2vw, 0.95rem)",
                            }}
                          >
                            <span
                              style={{
                                color: "#b68b40",
                                minWidth: "20px",
                              }}
                            >
                              •
                            </span>
                            <span style={{ color: "#2c3e50" }}>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  {/* CTA Button */}
                  <div className="mt-4">
                    <a
                      href="#contact"
                      className="btn d-inline-block rounded-pill"
                      style={{
                        backgroundColor: "#b68b40",
                        color: "white",
                        padding:
                          "clamp(12px, 3vw, 14px) clamp(30px, 5vw, 40px)",
                        fontWeight: "600",
                        fontSize: "clamp(0.95rem, 2vw, 1rem)",
                        border: "2px solid #b68b40",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#b68b40";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = "#b68b40";
                        e.target.style.color = "white";
                      }}
                    >
                      Request Sample
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Badges - Hidden (bisa di-uncomment jika diperlukan) */}
        {/* <div className="row mt-5" data-aos="fade-up">
          <div className="col-12">
            <div
              className="d-flex justify-content-center align-items-center gap-3 gap-lg-5 flex-wrap p-4"
              style={{
                backgroundColor: "#f8f9fa",
                borderRadius: "20px",
              }}
            >
              <div className="text-center">
                <span style={{ fontSize: "2rem", color: "#b68b40" }}>🌱</span>
                <p className="mb-0 mt-2" style={{ color: "#1a3e3f", fontWeight: "600" }}>
                  100% Natural
                </p>
              </div>
              <div className="text-center">
                <span style={{ fontSize: "2rem", color: "#b68b40" }}>🔬</span>
                <p className="mb-0 mt-2" style={{ color: "#1a3e3f", fontWeight: "600" }}>
                  Lab Tested
                </p>
              </div>
              <div className="text-center">
                <span style={{ fontSize: "2rem", color: "#b68b40" }}>🏭</span>
                <p className="mb-0 mt-2" style={{ color: "#1a3e3f", fontWeight: "600" }}>
                  Premium Quality
                </p>
              </div>
              <div className="text-center">
                <span style={{ fontSize: "2rem", color: "#b68b40" }}>📦</span>
                <p className="mb-0 mt-2" style={{ color: "#1a3e3f", fontWeight: "600" }}>
                  Ready Stock
                </p>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Products;
